import { render, staticRenderFns } from "./TwoFactorVerificationForm.vue?vue&type=template&id=5e790f36&scoped=true&"
import script from "./TwoFactorVerificationForm.vue?vue&type=script&lang=ts&"
export * from "./TwoFactorVerificationForm.vue?vue&type=script&lang=ts&"
import style0 from "./TwoFactorVerificationForm.vue?vue&type=style&index=0&id=5e790f36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e790f36",
  null
  
)

export default component.exports